import {
  AppBar,
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Toolbar,
  Typography,
  ListItemText,
  ListItemIcon,
  ListItem,
  List,
  CardActions,
  Grid,
  CardContent,
  CircularProgress,
  Card, Popover, InputBase, Divider
} from '@material-ui/core';
import SearchBar from 'material-ui-search-bar';
import MenuIcon from '@material-ui/icons/Menu';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import React, { useRef, useState, useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import NotificationsPopover from 'src/components/NotificationsPopover';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Flag from 'react-world-flags';
import PersonIcon from '@material-ui/icons/Person';
import { useTranslation } from 'react-i18next';
import CallEndIcon from '@material-ui/icons/CallEnd';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import clsx from 'clsx';
import SearchIcon from '@material-ui/icons/Search';
import axios from 'src/utils/axiosCatalog';
import { sc } from 'src/utils/Common';
import {
  getUser,


  handleLogoutMain

} from 'src/utils/Common';
import { useOktaAuth } from '@okta/okta-react';
import { Link as RouterLink } from 'react-router-dom';
import WorkOrderDetailPage from 'src/views/Operation/WorkOrderDetail';
import { baseURL } from 'src/utils/contants';
import SelectLanguage from 'src/components/SelectLanguage';
import { fade } from '@material-ui/core/styles';
import {
  getTenantMapData, getNotifications,
  readNotifications, commonActions
} from '../../store/slices/commonSlice';
import moment from 'moment';


const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  table: {
    minWidth: 600
  },
  flexGrow: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1,
    marginBottom: theme.spacing(-1),
    marginLeft: theme.spacing(1)
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.55),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.65),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '70ch',
      '&:focus': {
        width: '70ch',
      },
    },
  },
  SearchDiv: {
    minWidth: 600,
    minHeight: 370,
  },
  SearchDivForThreeChar: {
    minWidth: 600,
    minHeight: 40,
  },
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
}));
const DefaultAddress = [
  {
    AddressType: '',
    Address: '',
    State: '',
    AddressItem: '',
    Apartment: '',
    City: '',
    District: '',
    DoorNr: '',
    Latitude: 0,
    Longitude: 0,
    Neighborhood: '',
    PostCode: '',
    Region: '',
    Street: '',
    PrimaryAddress: true,
    AddressTypeId: 0,
    AddressId: 0
  }
];
function TopBar({ onOpenNavBar, className }) {
  const classes = useStyles();
  const history = useHistory();
  const notificationsRef = useRef(null);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [MenuShow, setMenuShow] = useState(false);
  const { t } = useTranslation('common');
  const [TenantData, setTenantData] = useState([]);
  const [TenantDataFull, setTenantDataFull] = useState([]);
  const [CountryPopup, setCountryPopup] = useState(false);
  const [SearchData, setSearchData] = React.useState([]);
  const [loading, setloading] = useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [workOrderId, setworkOrderId] = React.useState(0);
  const [Search, setSearch] = useState('');
  const SessionUser = getUser();
  const { oktaAuth } = useOktaAuth();
  const [workOrderPopUp, setWorkOrderPopUp] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const tenantMapData = useSelector((state) => state.common.TenantMapData);
  const notifications = useSelector((state) => state.common.Notifications);
  const UnReadedNotificaionslength = useSelector((state) => state.common.UnReadedNotificaionLenght);
  // const [notificationsLenght, setNotificationsLenght] = useState(0);
  const [searched, setSearched] = useState('');
  const isAppSystemControl = process.env.REACT_APP_SYSTEM;
  const dispatch = useDispatch();


  const [tokenExpirationTime, setTokenExpirationTime] = React.useState('')


  // var ImageApp = "";
  // if (SessionUser.Role === 1) {
  //   ImageApp = "/images/LogoPartner.png"
  // }
  // if (SessionUser.Role === 2) {
  //   ImageApp = "/images/LogoPartner.png"
  // }
  // if (SessionUser.Role === 3) {
  //   ImageApp = "/images/LogoCrm.png"
  // }
  // if (SessionUser.Role === 4) {
  //   ImageApp = "/images/LogoPortal.png"
  // }
  // if (SessionUser.Role === 5) {
  //   ImageApp = '/images/LogoAdmin.png'
  // }

  const [imageControl, setimageControl] = React.useState("/images/LogoPortal.png");

  useEffect(() => {
    dispatch(getTenantMapData());
    var tokenExpirationDate = JSON.parse(localStorage.getItem('okta-token-storage'))
    var dateFormat = new Date(tokenExpirationDate.accessToken.expiresAt * 1000)
    var date = moment(dateFormat).format('DD-MM-YYYY HH:ss')
    setTokenExpirationTime(date)
  }, [dispatch]);

  useEffect(() => {
    dispatch(getNotifications(SessionUser.TechnicianId));
    // setNotificationsLenght(UnReadedNotificaionslength)
  }, [dispatch]);

  useEffect(() => {
    // Component ilk kez yüklendiğinde ve her 5 dkda bir API'ye istek gönderme
    const interval = setInterval(() => {
      dispatch(getNotifications(SessionUser.TechnicianId));
      // setNotificationsLenght(UnReadedNotificaionslength)
    }, 180000);
    // Component temizlendiğinde interval'i kaldırma
    return () => clearInterval(interval);
  }, [dispatch]);

  const ReadNotifications = () => {
    setShowNotificationList(false)
    const maxId = Math.max(...notifications.map(o => o.Id))
    dispatch(readNotifications(SessionUser.TechnicianId, maxId));
    dispatch(commonActions.ReadAllNotifications());
    // setNotificationsLenght(0);
    console.log(notifications);
  }

  useEffect(() => {
    var arrayForSort = [...tenantMapData]
    // var sortedTenantMapData = arrayForSort.sort((a, b) => a.Tenant.localeCompare(b.Tenant))
    setTenantData(arrayForSort);
    setTenantDataFull(arrayForSort);
  }, [tenantMapData]);


  const handleClose = () => {
    setAnchorEl(null);
  };

  const setSearchFind = (event) => {
    setSearch(event.target.value);
    setSearchData([]);
    setloading(true);
  };

  const Logout = async () => {
    handleLogoutMain();
    await oktaAuth.signOut();
  };
  const setLocalContentSearh = (event) => {
    sessionStorage.removeItem('SearhContentSearchParam');
    sessionStorage.setItem('SearhContentSearchParam', Search);
    history.push('/Bulletin');
    handleClose();
    setSearch('');
  };
  const setLocalWorkOrderSearh = (event) => {
    setworkOrderId(Search);
    handleClose();
    setSearch('');
    setWorkOrderPopUp(true);
  };

  const setLocalSearhResult = (event, item) => {
    setworkOrderId(item.SearchId);
    handleClose();
    setSearch('');
    setWorkOrderPopUp(true);
  };

  const changeCountry = (country) => {
    setCountryPopup(false);
    confirmAlert({
      message: t('ChangingCoutryQuestion'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => changeCountryYes(country)
        },
        {
          label: t('Hayir'),
          onClick: () => { setCountryPopup(true); }
        }
      ]
    });
  };

  const changeCountryYes = (country) => {
    const data = {
      TechnicianId: SessionUser.TechnicianId,
      TenantId: country.TenantId,
      TenantCode: country.CountryCode
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/ChangeCountry', data, config)
      .then((response) => {
        handleLogoutMain();
        window.location.href = window.location.origin;
      }).catch((error) => {

      });
  };

  const setMenuShowFnc = () => {
    if (MenuShow) {
      setMenuShow(false);
    } else {
      setMenuShow(true);
    }
    onOpenNavBar();
  };

  const Beyaz = {
    color: '#FFFFFF'
  };

  const setLocalWorkCaseSearchResult = event => {

    setSearchData([]);
    setloading(true);
    if (Search.length > 2) {
      axios
        .get(
          '/GetSearchMain/2/' +
          Search.toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)
        )
        .then(res => {
          const response = res.data;
          setloading(false);
          setSearchData(response);
          //setLocalSearhResult("", response[0]);
        })
        .catch(err => {
          setSearchData([]);
          setloading(false);
        });
    }
  };

  const requestSearch = (searchedVal) => {
    const filteredRows = TenantDataFull.filter((item) => sc(
      item.Tenant,
      searchedVal
    ));
    setTenantData(filteredRows);
  };
  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  const handleEnterKey = (e) => {

    if ((localStorage.getItem('i18nextLng') === "zh-TW") || (localStorage.getItem('i18nextLng') == "zh-CN") || (localStorage.getItem('i18nextLng') == "zh-Chs")) {

      if (e.nativeEvent.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        setAnchorEl(e.currentTarget)
      }
    }
    else {
      setAnchorEl(e.currentTarget);
    }
  }

  return (
    <AppBar
      className={clsx(classes.root, className)}
      style={{ background: '#1D3343' }}
    >
      <Toolbar>
        <IconButton
          className={classes.menuButton}
          style={Beyaz}
          onClick={setMenuShowFnc}
          data-tour="OpenNavbarButton"
        >
          {MenuShow ? <MenuIcon /> : <MenuOpenIcon />}
        </IconButton>
        <RouterLink to="/profile/1/timeline" data-tour="SiriusButton">
          <img
            height="55px"
            alt="Logo"
            src={imageControl} />
        </RouterLink>
        <Typography variant="h6" className={classes.title} />
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder={t('lblGlobalSearch')}
            autoFocus
            value={Search}
            onKeyUp={handleEnterKey}
            onChange={(event) => setSearchFind(event)}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ 'aria-label': 'search' }}
          />
          <Popover
            disableAutoFocus
            onKeyDown={handleClose}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <Card className={clsx(classes.root, className)}>
              {Search.length < 3
                ? (
                  <CardContent className={classes.SearchDivForThreeChar}>
                    <Typography className={classes.typography} style={{ textAlign: 'center' }}>{t('Lütfen aramak için üç karakter girin.')}</Typography>
                  </CardContent>
                )
                : SearchData.length === 0
                  ? (
                    <CardContent className={classes.SearchDivForThreeChar}>
                      {loading ? (
                        <CircularProgress
                          status="loading"
                          style={{ marginLeft: '50%' }}
                        />
                      )
                        : <Typography className={classes.typography} style={{ textAlign: 'center' }}>{t('Aradığınız sonuç bulunmamaktadır.')}</Typography>}

                    </CardContent>
                  )
                  : (
                    <CardContent className={classes.SearchDiv}>
                      {SearchData.map((option) => (
                        <List key={option.SearchId}
                          onClick={(event) => setLocalSearhResult(event, option)}
                        >
                          <ListItem button>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={2} align="left">
                                <Typography variant="caption" display="block" gutterBottom>
                                  {option.SearchId}
                                </Typography>
                                <PersonIcon fontSize="small" />
                                <Typography variant="h6" gutterBottom>
                                  {option.Search}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={5} align="left">
                                <Grid item><CallEndIcon fontSize="small" /></Grid>
                                {option.Phones?.map((item, index) => (
                                  <Typography variant="body2" display="block" key={index}>
                                    {`${item.Phone}  ${item.PhoneType}`}
                                  </Typography>
                                )
                                )}
                              </Grid>
                              <Grid item xs={12} sm={5} align="left">
                                <Grid item><LocationOnIcon fontSize="small" /></Grid>
                                {option.Addresses?.map((item, index) => (
                                  <Typography variant="body2" display="block" key={index}>
                                    {`${item.AddressType}  ${item.Address}`}
                                  </Typography>
                                )
                                )}
                              </Grid>
                            </Grid>
                          </ListItem>
                        </List>
                      ))}
                    </CardContent>
                  )}
              <CardActions>
                <Button
                  size="small"
                  onClick={(event) => setLocalContentSearh(event)}
                  color="primary"
                >
                  {t('ContentGlobalSearch')}
                </Button>
                <Divider orientation="vertical" flexItem />
                <Button
                  size="small"
                  onClick={(event) => setLocalWorkOrderSearh(event)}
                  color="primary"
                >
                  {t('ContentWorkOrderSearch')}
                </Button>
                {/* <Divider orientation="vertical" flexItem />
                <Button
                  size="small"
                  onClick={event => setLocalWorkCaseSearchResult(event)}
                  color="primary"
                >
                  {t('WorkCaseGlobalSearch')}
                </Button> */}
              </CardActions>
            </Card>
          </Popover>
        </div>
        <Typography variant="h6" className={classes.title} />
        <IconButton
          className={classes.iconButton}
          onClick={() => setCountryPopup(true)}
        >

          <Badge
            style={Beyaz}
          >
            <Typography style={Beyaz}>
              {SessionUser.Tenant}
            </Typography>
          </Badge>
        </IconButton>
        <IconButton
          className={classes.iconButton}
          onClick={() => setCountryPopup(true)}
        >

          <Badge
            style={Beyaz}
          >
            <Flag code={SessionUser.TenantCode} height="16" />
          </Badge>
        </IconButton>
        <IconButton
          className={classes.iconButton}
          onClick={() => setShowNotificationList(true)}
          ref={notificationsRef}>
          <Badge
            style={Beyaz}
            badgeContent={UnReadedNotificaionslength}
          >
            <NotificationsActiveIcon style={{ color: 'white' }} />
          </Badge>
        </IconButton>
        <SelectLanguage />
        <IconButton
          className={classes.menuButton}
          style={Beyaz}
          onClick={() => Logout()}
          data-tour="LogoutButton"
        >
          <ExitToAppIcon style={{ color: 'white' }} />
        </IconButton>
      </Toolbar>

      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        // onClickNotification={handleClickNotification}
        onClose={() => ReadNotifications()}
        open={showNotificationList}
      // handleDeleteAll={handleDeleteAll}
      />


      <Dialog
        open={CountryPopup}
        maxWidth="xs"
        fullWidth
        onClose={() => setCountryPopup(false)}
      >
        <DialogTitle color="primary">{t('lblChangeCountry')}</DialogTitle>
        <DialogContent dividers>
          <SearchBar
            value={searched}
            placeholder={t('lblSearch')}
            onChange={searchVal => requestSearch(searchVal)}
            onCancelSearch={() => cancelSearch()}
            style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
          />
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
          >
            {TenantData ? TenantData.map((item) => (
              <ListItem
                button
                key={item.TenantId}
                onClick={() => changeCountry(item)}
              >
                <ListItemIcon>
                  <Flag code={item.CountryCode} height="16" />
                </ListItemIcon>
                <ListItemText primary={` ${item.Tenant}`} />
              </ListItem>
            )) : <div />}
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setCountryPopup(false)}
            color="primary"
          >
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={workOrderPopUp}
        fullWidth
        maxWidth="xl"
        onClose={() => setWorkOrderPopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: 'center' }}
        >
          {t('Work Order Detail')}
        </DialogTitle>
        <DialogContent>
          <WorkOrderDetailPage WorkOrderId={workOrderId} />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => setWorkOrderPopUp(false)}
            aria-label="close"
            component="span"
            variant="contained"
            endIcon={<CloseIcon />}
          >
            {' '}
            {t('Close')}
          </Button>
        </DialogActions>
      </Dialog>
      <div style={{ position: 'absolute', bottom: 0, right: 20, fontSize: 15 }}>
        {isAppSystemControl}
      </div>
      {/* <div style={{ position: 'absolute', bottom: 0, right: 150, fontSize: 15 }}>
        {'Your token will expire at ' + tokenExpirationTime}
      </div> */}
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBar: PropTypes.func
};

export default connect((state) => ({ alertReducer: state.alertReducer }), {

})(TopBar);
